import { FormInstance } from 'antd';
import React, { FC, useCallback } from 'react';
import { Button } from 'shared/ui/Button';

interface ContinueButtonProps {
  formInstance: FormInstance;
  isDisabled: boolean;
  setProceedToPaymentMode: () => void;
  label: string;
}

export const ContinueButton: FC<ContinueButtonProps> = (props) => {
  const { isDisabled, setProceedToPaymentMode, formInstance, label } = props;

  const handleSubmit = useCallback(() => {
    setProceedToPaymentMode();
    formInstance.submit();
  }, [formInstance, setProceedToPaymentMode]);

  return (
    <>
      <Button containerClassName="w-full" size="large" isDisabled={isDisabled} onClick={handleSubmit}>
        {label}
      </Button>
    </>
  );
};
